import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { GroupType } from '../../../../state/ducks/auth/types';
import { userManagementSelectors } from '../../../../state/ducks/userManagement';
import { MultiValueRemove, selectStyles, selectTheme } from '../../../components/forms/fields/Autocomplete/Autocomplete';
import Text from '../../../components/Text';

interface Props {
  parentGroups: any[]
  setParentGroups: (selectedItems: any) => void
  currentGroupId: string
}

const ParentGroups: React.FunctionComponent<Props> = ({
  parentGroups,
  setParentGroups,
  currentGroupId,
}) => {
  const allGroups = useSelector(userManagementSelectors.getOfficialGroups);
  const availableGroups = allGroups.filter((group) => group.value !== currentGroupId);

  const multiValueRemove = (props) =>
    props.data.type === GroupType.MANAGMENT
      ? <MultiValueRemove {...props} />
      : <></>;

  return (
    <Grid>
      <Box width={700} mt={5}>
        <Typography variant="h4" style={{ marginBottom: '16px' }}>
          <Text translation="common.parent.groups" />
        </Typography>
        <Select
          id="Group-addParentGroups"
          isMulti={true}
          options={availableGroups}
          onChange={(state: any) => setParentGroups(state)}
          value={parentGroups}
          components={{ MultiValueRemove: multiValueRemove }}
          styles={selectStyles}
          theme={selectTheme}
        />
      </Box>
    </Grid>
  );
};

export default ParentGroups;
